export default "__VITE_ASSET__CG3Jl8Va__"